<template>
  <div class="flex tutor">
    <div class="basic">
      <tutor-profile :tutor="tutor" :edit_id="edit_id"></tutor-profile>
    </div>
    <div class="m-AddBox">
      <tutor-students-index :tutor="tutor"></tutor-students-index>
    </div>
    <div class="m-support">
      <tutor-history :tutor="tutor" :condition="condition" :edit_id="edit_id" type="true"></tutor-history>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tutor: Object,
    condition: Object,
    edit_id: Object
  },
  data () {
    return {
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.tutor_id === this.tutor.id) {
      alert('先生情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.tutor_channel_id) {
      alert('登録媒体が編集中です')
      return
    }
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.tutor {
  &:after {
    content: "\f19d";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
.basic {
  max-width: 33%;
  flex-basis: 33%;
}
.m-AddBox {
  max-width: 33%;
  flex-basis: 33%;
}
.m-support {
  max-width: 34%;
  flex-basis: 34%;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
.m-box__inner2 {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// TutorIndex.vue?2350df8f